import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, Badge, Empty } from "@/lib/ui";

const ICONS = {
  "Added Product": "fa-plus", "Deleted Product": "fa-trash", "Deleted Product (Sold)": "fa-trash", "Reduced Inventory (Sold)": "fa-arrow-trend-down",
  "Updated Company Profile": "fa-building",
  "Placed Payment": "fa-receipt", "Changed Password": "fa-key",
};

export default function SellerHistory() {
  const [rows, setRows] = useState([]);
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/seller/history").then(({ data }) => setRows(data)); api.get("/seller/inventory-logs").then(({ data }) => setLogs(data)); }, []);
  const totalSold = logs.reduce((s, l) => s + (l.sale_value || 0), 0);

  return (
    <div>
      <h1 className="font-head text-2xl font-extrabold text-slate-900">Activity History</h1>
      <p className="mt-1 text-sm text-slate-500">A record of your actions on Deadstock.live.</p>

      <div className="mt-5 rounded-2xl border border-slate-200 bg-white p-4" data-testid="inventory-audit">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <p className="text-sm font-bold uppercase tracking-wide text-slate-500"><i className="fa-solid fa-arrow-trend-down mr-1 text-emerald-600" /> Inventory Reductions (Sales Audit)</p>
          <p className="text-sm font-bold text-emerald-700" data-testid="inventory-audit-total">Total sold till date: ₹{Math.round(totalSold).toLocaleString("en-IN")}</p>
        </div>
        {logs.length === 0 ? <p className="mt-2 text-xs text-slate-400">No inventory reductions yet.</p> : (
          <div className="mt-3 overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead><tr className="text-xs uppercase text-slate-400"><th className="py-1 pr-3">Date</th><th className="py-1 pr-3">Product</th><th className="py-1 pr-3">Before</th><th className="py-1 pr-3">After</th><th className="py-1 pr-3">Sold</th><th className="py-1 pr-3">Rate</th><th className="py-1">Sale Value</th></tr></thead>
              <tbody>
                {logs.map((l) => (
                  <tr key={l.id} className="border-t border-slate-100" data-testid={`inv-log-${l.id}`}>
                    <td className="py-1.5 pr-3 text-xs text-slate-500">{new Date(l.created_at).toLocaleString()}</td>
                    <td className="py-1.5 pr-3 font-semibold text-slate-800">{l.product}{l.type === "deleted" ? <span className="ml-1 text-[10px] uppercase text-slate-400">deleted</span> : null}</td>
                    <td className="py-1.5 pr-3">{l.prev_quantity} {l.unit}</td>
                    <td className="py-1.5 pr-3">{l.new_quantity} {l.unit}</td>
                    <td className="py-1.5 pr-3 font-semibold text-emerald-700">{l.sold_quantity} {l.unit}</td>
                    <td className="py-1.5 pr-3">₹{Number(l.rate).toLocaleString("en-IN")}</td>
                    <td className="py-1.5 font-bold text-slate-900">₹{Math.round(l.sale_value).toLocaleString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {rows.length === 0 ? <div className="mt-6"><Empty text="No activity recorded yet" icon="fa-clock-rotate-left" /></div> : (
        <div className="mt-5 space-y-2">
          {rows.map((r) => (
            <div key={r.id} data-testid={`activity-${r.id}`} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-orange-50 text-orange-600"><i className={`fa-solid ${ICONS[r.action] || "fa-circle-dot"}`} /></span>
              <div className="flex-1">
                <p className="font-semibold text-slate-800">{r.action}</p>
                {r.detail && <p className="text-xs text-slate-500">{r.detail}</p>}
              </div>
              <span className="text-xs text-slate-400">{new Date(r.created_at).toLocaleString()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
